export default __webpack_public_path__ + "static/media/1 (1).a9a597ba.jpg";